const NoIsInMySchoolReasons = Object.freeze({
    IsInAnotherSchool: 1,
    Quit: 2,
    Others: 3
});

export default NoIsInMySchoolReasons;